import { render } from "./PaintingDrywalsView.vue?vue&type=template&id=f9ba9418"
import script from "./PaintingDrywalsView.vue?vue&type=script&lang=js"
export * from "./PaintingDrywalsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__